var turnOnSmListeners,
    turnOffSmListeners;
(function($) {
	$(function() {
		var fixedHoverLayer = $('#fixed-hover-layer');
		turnOnSmListeners = function() {
			var openedMenu = [],//list of opened menus
			    activeMenu = [],//list of active menu items
			    actionAllowed = true,//for correct order of animations
			    maxMenuLevel = 3;
			$('.tab-menu-level-2-wrapper, .tab-menu-level-3').mCustomScrollbar({
				axis: 'y',
				scrollbarPosition: 'outside',
				autoHideScrollbar: true,
				autoExpandScrollbar: true,
				mouseWheel: {
					preventDefault: true
				},
				documentTouchScroll: false,
				callbacks: {
					onOverflowY: function() {
						$(this).addClass('overflowed');
					},
					onTotalScroll: function() {
						$(this).addClass('scroll-finish');
					},
					onScrollStart: function() {
						var $this = $(this);
						if ($this.hasClass('scroll-finish')) {
							$this.removeClass('scroll-finish');
						}
					}
				}
			});
			$('.on-panel-menu-item').on('click.sm', function(e) {
				e.preventDefault();
				var currItem = $(this);
				if (currItem.hasClass('active')) {
					closeMenuBlock(currItem, 0);
					hideFixedHoverLayer();
				} else {
					showFixedHoverLayer();
					if (activeMenu[0]) {
						closeOneOpenOther(currItem, 0);
					} else {
						openMenuBlock(currItem, 0);
					}
				}
			});
			$('.tab-menu-item').on('click.sm', function(e) {
				e.preventDefault();
				var currItem = $(this),
				    currItemLevel = currItem.data('mob-menu-level');
				if (currItem.hasClass('active')) {
					closeMenuBlock(currItem, currItemLevel);
				} else {
					if (activeMenu[currItemLevel]) {
						closeOneOpenOther(currItem, currItemLevel);
					} else {
						openMenuBlock(currItem, currItemLevel);
					}
				}
			});
			fixedHoverLayer.on('click.sm', function() {
				activeMenu[0].click();
			});
			function renderBanner(item) {
				var banner = $(item.data('tab-banner'));
				if (banner.hasClass('shown')) {
					banner.removeClass('shown');
				} else {
					banner.addClass('shown');
				}
			}
			function closeOneOpenOther(menuItem, menuLevel) {
				closeMenuBlock(activeMenu[menuLevel], menuLevel);
				openMenuBlock(menuItem, menuLevel);
			}
			function openMenuBlock(menuItem, menuLevel) {
				var menuToOpen = $(menuItem.data('mob-menu-goal'));
				tryOpen();
				function tryOpen() {
					if (actionAllowed && !activeMenu[menuLevel]) {
						open();
					} else {
						setTimeout(tryOpen, transitionDuration);
					}
				}
				function open() {
					actionAllowed = false;
					var animFinished = transitionDuration;
					if (menuItem.attr('data-tab-banner')) {
						renderBanner(menuItem);
						animFinished += transitionDuration;
					}
					openedMenu[menuLevel] = menuToOpen.addClass('opened');
					activeMenu[menuLevel] = menuItem.addClass('active');
					setTimeout(allowAction, animFinished);
				}
			}
			function closeMenuBlock(menuItem, menuLevel) {
				if (menuLevel < maxMenuLevel - 1) {
					var activeInner = checkIfHasActiveInner(menuLevel);
				}
				if (activeInner) {
					for (var i = activeMenu.length - 1; i >= menuLevel; i--) {
						if (activeMenu[i]) {
							tryClose(i)
						}
					}
					function tryClose(i) {
						if (actionAllowed) {
							close(activeMenu[i], i);
						} else {
							setTimeout(tryClose, transitionDuration, i);
						}
					}
				} else {
					close(menuItem, menuLevel);
				}
				function close(menuItem, menuLevel) {
					actionAllowed = false;
					var animFinished = transitionDuration;
					var menuToClose = $(menuItem.data('mob-menu-goal'));
					if (menuItem.attr('data-tab-banner')) {
						renderBanner(menuItem);
						animFinished += transitionDuration;
					}
					menuToClose.removeClass('opened');
					menuItem.removeClass('active');
					openedMenu[menuLevel] = null;
					activeMenu[menuLevel] = null;
					setTimeout(allowAction, animFinished);
				}
			}
			function allowAction() {
				actionAllowed = true;
			}
			function checkIfHasActiveInner(menuLevel) {
				if (activeMenu[menuLevel + 1]) {
					return true;
				}
			}
			function showFixedHoverLayer() {
				if (!fixedHoverLayer.hasClass('shown')) {
					fixedHoverLayer.addClass('shown');
				}
			}
			function hideFixedHoverLayer() {
				if (fixedHoverLayer.hasClass('shown')) {
					tryHide();
					function tryHide() {
						if (actionAllowed) {
							hide()
						} else {
							setTimeout(tryHide, transitionDuration);
						}
					}
					function hide() {
						fixedHoverLayer.removeClass('shown');
					}
				}
			}
		}
		turnOffSmListeners = function($) {
			$('.tab-menu-level-2-wrapper, .tab-menu-level-3').mCustomScrollbar('destroy');
			$('.on-panel-menu-item').off('click.sm');
			$('[data-tab-banner]').off('click.sm');
			$('.tab-menu-item').off('click.sm');
			fixedHoverLayer.off('click.sm');
		}
	});
})(jQuery)